import { TextInput as PaperTextInput } from "react-native-paper";
import { forwardRef } from "react";
import { TextInput as RNTextInput, Platform, StyleProp, ViewStyle } from "react-native";
import { HelperText } from "./styled";

export interface TextInputProps extends Omit<React.ComponentProps<typeof PaperTextInput>, "error"> {
  error?: { error?: boolean; message?: string };
  className?: string;
  errorClassName?: string;
}

export const ErrorHelperText = ({
  error,
  children,
  errorClassName,
}: {
  error: {
    message?: string;
  };
  children: React.ReactNode;
  errorClassName?: string;
}) => (
  <HelperText type="error" visible={!!error} className={`text-regular-tight font-400 pl-1 ${errorClassName}`} padding="none">
    {children}
  </HelperText>
);

export type Ref = RNTextInput;

const TextInput = forwardRef<Ref, TextInputProps>(({ error, errorClassName, ...props }: TextInputProps, ref) => (
  <>
    <PaperTextInput
      // https://github.com/callstack/react-native-paper/issues/4041#issuecomment-1695001476
      outlineStyle={{ ...(Platform.OS === "web" && { marginTop: "2px" }) } as StyleProp<ViewStyle>}
      theme={{
        roundness: 8,
      }}
      mode="outlined"
      error={!!error}
      {...props}
      ref={ref}
    />
    {!!error?.message && (
      <ErrorHelperText error={error} errorClassName={errorClassName}>
        {error?.message}
      </ErrorHelperText>
    )}
  </>
));

export const Icon = PaperTextInput.Icon;

export default TextInput;
